import { Checkbox, CheckboxRootProps } from "@chakra-ui/react"
import { ReactNode } from "react"
import { AugmentationPanelRow } from "./AugmentationPanelRow"
import { AUGMENTATION_PANEL_CHECK_CONTROL_PROPS } from "./augmentationPanelStyles"

export type AugmentationPanelCheckboxProps = CheckboxRootProps & {
  children: ReactNode
}

/**
 * A panel row you can check. The whole row is the control, so the label, the
 * ring, and the space between them all toggle it.
 */
export function AugmentationPanelCheckbox({
  children,
  ...rootProps
}: AugmentationPanelCheckboxProps) {
  return (
    <AugmentationPanelRow
      asChild
      cursor={rootProps.disabled ? "not-allowed" : "pointer"}
    >
      <Checkbox.Root {...rootProps}>
        <Checkbox.HiddenInput />
        <Checkbox.Control {...AUGMENTATION_PANEL_CHECK_CONTROL_PROPS}>
          <Checkbox.Indicator />
        </Checkbox.Control>
        <Checkbox.Label
          flex="1"
          lineClamp={1}
          minW={0}
          textStyle="augmentationPanel"
        >
          {children}
        </Checkbox.Label>
      </Checkbox.Root>
    </AugmentationPanelRow>
  )
}
